import { Form, type InferType, useForm, yup, yupResolver } from 'form';
import { useTranslation } from 'i18n';
import { ConfirmationButton } from 'ui';

import { TradeCompanySiteMaterialPicker } from '../../../site-material';

const schema = yup.object().shape({
  trade_company: yup.string(),
  trade_company_site_material: yup.string(),
});

export type SampleMaterialEditFormValues = InferType<typeof schema>;

export const SampleMaterialEditForm = ({ onSubmit }: { onSubmit: (data: SampleMaterialEditFormValues) => void }) => {
  const { t } = useTranslation('features');
  const form = useForm({ resolver: yupResolver(schema) });
  return (
    <Form {...form}>
      <TradeCompanySiteMaterialPicker />

      <ConfirmationButton
        title={t('evidence.sampleMaterialEditForm.warning.title')}
        message={t('evidence.sampleMaterialEditForm.warning.editMessage')}
        onConfirm={form.handleSubmit(onSubmit)}
      >
        {t('evidence.sampleMaterialEditForm.actions.edit')}
      </ConfirmationButton>
    </Form>
  );
};
